import { render, staticRenderFns } from "./StockCardIndex.vue?vue&type=template&id=51b380d5&scoped=true&"
import script from "./StockCardIndex.vue?vue&type=script&lang=js&"
export * from "./StockCardIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b380d5",
  null
  
)

export default component.exports